<mat-toolbar class="topbar admin-dark-topbar">
  <button mat-icon-button type="button" (click)="backToAdmin()" title="Back to Admin">
    <mat-icon>arrow_back</mat-icon>
  </button>
  <button mat-button type="button" (click)="goHome()">Career Roles</button>
  <span class="spacer"></span>
  <button mat-stroked-button type="button" [matMenuTriggerFor]="toolsMenu" [disabled]="busy">
    <mat-icon>build</mat-icon>
    Tools
  </button>
  <mat-menu #toolsMenu="matMenu">
    <a mat-menu-item *ngFor="let link of toolLinks" [routerLink]="link.path">{{ link.label }}</a>
    <button mat-menu-item type="button" (click)="removeSoftSkillsCategory()" [disabled]="busy">
      Remove Soft Skills (all roles)
    </button>
  </mat-menu>
</mat-toolbar>

<main class="shell-body">
  <app-jobs-panel [roleSlug]="contextRoleSlug"></app-jobs-panel>
  <router-outlet></router-outlet>
</main>
